import { render, staticRenderFns } from "./VideoProgressBar.vue?vue&type=template&id=3af801f0&scoped=true&"
import script from "./VideoProgressBar.vue?vue&type=script&lang=js&"
export * from "./VideoProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./VideoProgressBar.vue?vue&type=style&index=0&id=3af801f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af801f0",
  null
  
)

export default component.exports